import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

export const FlexGrid = styled.footer`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  height: 34px;
  line-height: 34px;
  ${(props: IThemeProps) =>
    props.theme.colors.footerBackground !== "none" && "padding: 0 5px;"}
  background: ${(props: IThemeProps) => props.theme.colors.footerBackground};
`;

export const Col = styled.div`
  flex: 1;
  flex-direction: row;
  ${(props: IThemeProps) =>
    props.theme.colors.footerBackground !== "none" && "margin: 0 5px;"}
  justify-content: center;
`;

export const Col1 = styled(Col)`
  text-align: left;
`;

export const Col2 = styled(Col)`
  text-align: center;
  font-weight: 600;
`;

export const Col3 = styled(Col)`
  text-align: right;
`;

export const PrivacyPolicyLink = styled.a`
  text-decoration: underline;
  margin-left: 20px;
  font-size: ${(props: IThemeProps) => props.theme.typography.h300};
  color: ${(props: IThemeProps) => props.theme.colors.footerFont};
`;

export const Text = styled.span`
  vertical-align: middle;
  font-size: ${(props: IThemeProps) => props.theme.typography.h300};
  color: ${(props: IThemeProps) => props.theme.colors.footerFont};
  span {
    font-weight: 600;
  }
`;

export const TextCopyright = styled(Text)`
  font-size: ${(props: IThemeProps) => props.theme.typography.h600};
  margin-left: 18px;
  cursor: pointer;
`;
